import {
  LOADING_REPORTS_CHANGE_PAGE, LOAD_REPORTS_CHANGE_PAGE_SUCCESS,
  REPORTS_CHANGE_NOT_FOUND, LOAD_REPORTS_CHANGE_PAGE_ERROR, REPORTS_CHANGE_BAD_REQUEST,
} from 'constants/ActionTypes';
import {
  DECRYPT_FAILURE_CODE,
  SUCCESS, WARNING, ERROR, YES,
  INITIALIZATION_VECTOR, KEY, CLIENT_ERROR_RESPONSES,
} from 'constants/AppConstants';
import { call, put } from 'lib/redux';
import getReportDetailsService from 'services/getReportDetails.service';
import getReportImageFilesService from 'services/getReportImageFiles.service';
import updateReportsChangeService from 'services/updateReportsChange.service';
import { decodeAndDecrypt } from 'utils/app.utils';

export default function* loadReportsChangeSaga() {
  try {
    yield put({ type: LOADING_REPORTS_CHANGE_PAGE });

    const searchParams = new URLSearchParams(window.location.search);
    const encryptedReportID = searchParams.get('ReportId');
    const response = searchParams.get('Response');
    const addOnTypeChange = searchParams.get('AddOn');
    const signature = searchParams.get('signature'); // #genai

    const reportId = yield call(decodeAndDecrypt, encryptedReportID, KEY, INITIALIZATION_VECTOR);

    const requestBody = {
      ...(response !== null && { response: response === YES }),
      ...(addOnTypeChange !== null && { addOnTypeChange: addOnTypeChange === YES }),
    };

    const updateReportsChangeResponse = yield call(updateReportsChangeService, reportId, requestBody, signature);
    const reportImageFilesResponse = yield call(getReportImageFilesService, reportId, true);
    const reportDetailsResponse = yield call(getReportDetailsService, reportId, signature);

    if (reportDetailsResponse.status === CLIENT_ERROR_RESPONSES.STATUS_NOT_FOUND
      || reportImageFilesResponse.status === CLIENT_ERROR_RESPONSES.STATUS_NOT_FOUND
      || updateReportsChangeResponse.status === CLIENT_ERROR_RESPONSES.STATUS_NOT_FOUND) {
      yield put({ type: REPORTS_CHANGE_NOT_FOUND });
    }

    if (!updateReportsChangeResponse.ok && updateReportsChangeResponse.status !== CLIENT_ERROR_RESPONSES.STATUS_BAD_REQUEST) {
      const { json: error } = updateReportsChangeResponse;
      throw error;
    }
    if (!reportImageFilesResponse.ok) {
      const { json: error } = reportImageFilesResponse;
      throw error;
    }
    if (!reportDetailsResponse.ok) {
      const { json: error } = reportDetailsResponse;
      throw error;
    }

    const reportDetails = reportDetailsResponse.json;
    const reportTypeChange = updateReportsChangeResponse.json;
    const reportImageFiles = reportImageFilesResponse.json;
    if (updateReportsChangeResponse.status === CLIENT_ERROR_RESPONSES.STATUS_BAD_REQUEST) {
      yield put({
        type: REPORTS_CHANGE_BAD_REQUEST,
        message: reportTypeChange?.errorDescription,
        severity: ERROR,
      });
    } else {
      yield put({
        type: LOAD_REPORTS_CHANGE_PAGE_SUCCESS,
        message: reportTypeChange?.message,
        severity: updateReportsChangeResponse.status === CLIENT_ERROR_RESPONSES.STATUS_CONFLICT ? WARNING : SUCCESS,
        reportId,
        reportDetails,
        topImage: reportImageFiles?.topImage,
      });
    }
  } catch (error) {
    if (error.code === DECRYPT_FAILURE_CODE) yield put({ type: REPORTS_CHANGE_NOT_FOUND });
    else yield put({ type: LOAD_REPORTS_CHANGE_PAGE_ERROR });
  }
}
